import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectRentCommissionFilter } from 'shared/selectors/advancedFilters';

export const RentCommissionContainer: FC = () => {
  const { label, value, options } = useSelector(selectRentCommissionFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (newValue: number | null) => {
      onChange({ action: 'setRentCommission', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleChange} />
    </AdvancedFilterRow>
  );
};
